module.exports = __webpack_public_path__ + "static/media/services_coaching_1.31987802.jpg";